"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getTime = _interopRequireDefault(require("date-fns/getTime"));
var _roundToNearestMinutes = _interopRequireDefault(require("date-fns/roundToNearestMinutes"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _DATE_TIME_PICKER = _interopRequireDefault(require("../../../constants/date/DATE_TIME_PICKER"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Generates available time slots from original branch timing slots
 * @param {Array} branchTimeSlots
 * @param {Date} formattedOpenTime
 * @returns
 */
function generateAvailableTimeSlots() {
  var branchTimeSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var formattedSelectedDate = arguments.length > 1 ? arguments[1] : undefined;
  var formattedOpenTime = arguments.length > 2 ? arguments[2] : undefined;
  // round to the nearest 30 mins
  var roundedOpenTime = (0, _roundToNearestMinutes["default"])(formattedOpenTime, {
    nearestTo: _DATE_TIME_PICKER["default"].SLOT_INTERVAL
  });
  var timeStamp = (0, _getTime["default"])(roundedOpenTime);

  // console.log('** formattedOpenTime: ', formattedOpenTime, roundedOpenTime);

  // now compare branch slots with the formatted open time
  return (0, _filter2["default"])(branchTimeSlots, function (branchSlot) {
    var formattedBranchSlot = new Date("".concat(formattedSelectedDate, " ").concat(branchSlot));
    var branchSlotTimeStamp = (0, _getTime["default"])(formattedBranchSlot);
    return branchSlotTimeStamp >= timeStamp;
  });
}
var _default = exports["default"] = generateAvailableTimeSlots;